import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {CRS, latLng, LatLngBounds, Point} from "leaflet";
import {ImageSize, Photo, PhotoPath, Poi, PoiType, Route, Sector} from "../../models/data.model";
import {RestProvider} from "../../providers/rest/rest";
import {DataProvider} from "../../providers/data/data";
import {MapComponent} from "@yaga/leaflet-ng2";
import {PhotosViewerPage} from "../../pages/photos-viewer/photos-viewer";
import {NavController} from "ionic-angular";

@Component({
  selector: 'route-path-viewer',
  templateUrl: 'route-path-viewer.html'
})
export class RoutePathViewerComponent implements OnInit {

  @Input() photo: Photo;
  @Input() sectorId: number;
  @Input() siteId: number;
  @Input() isPoiOptional: boolean;
  isLoaded: boolean = false;
  markerUrl: string = "assets/marker/";
  public crs = CRS.Simple;
  public properties = {
    zoom: 1,
    lat: 0,
    lng: 0,
    minZoom: -10,
    maxZoom: 10,
    maxBounds: new LatLngBounds(latLng(-1, 0), latLng(0, 1)),
    input: [],
    output: []
  };
  poiIconSize: number = 30;
  isZoomInit: boolean = false;
  public popupAnchor: Point = new Point(0, -20);
  size: Point = new Point(this.poiIconSize,this.poiIconSize);
  photos: Photo[] = [];

  @ViewChild(MapComponent) map: MapComponent;

  constructor(public data: DataProvider, public navCtrl: NavController) {
  }

  protected openImage(url: string): void {
    const photo: Photo = {
      name: "photo",
      url: this.getPhotoUrl(url)
    };
    this.navCtrl.push(PhotosViewerPage, {
      photos: [photo]
    }).catch();
  }

  protected getPhotoUrl(photoName: string) : string {
    let photo: Photo = this.photos.find(photo_ => {
      return photo_.name == photoName;
    });
    return (photo) ? photo.url : "";
  }

  protected getPoisVisibles(): Poi[] {
    if (this.isPoiOptional) return this.getPhotoPath().pois;
    return this.getPhotoPath().pois.filter(poi => {return this.isAPoiOptional(poi);});
  }

  protected isAPoiOptional(poi: Poi): boolean {
    if (this.isPoiOptional) return true;
    switch (poi.type) {
      case PoiType.RelaisNotEquipeRappel:
      case PoiType.RelaisEquipeRappel:
      case PoiType.Cotation:
        return true;
      default :
        return false;
    }
  }

  protected isPoiIcon(poi: Poi): boolean {
    return poi.type != PoiType.Cotation;
  }

  protected getMarkerPoiType(poiType: PoiType): string {
    let marker = "";
    switch (poiType) {
      case PoiType.EnvironmentalAlert:
        marker += "marker-triangle-flower.png";
        break;
      case PoiType.AlerteSecurite:
        marker += "marker-triangle-exclamation.png";
        break;
      case PoiType.Cotation:
        marker += "marker.png"; // TODO
        break;
      case PoiType.DescenteLeft:
        marker += "marker-arrow-left.png";
        break;
      case PoiType.DescenteRight:
        marker += "marker-arrow-right.png";
        break;
      case PoiType.RelaisEquipeRappel:
        marker += "marker-rond-rouge.png";
        break;
      case PoiType.RelaisNotEquipeRappel:
        marker += "marker-rond-jaune.png";
        break;
      case PoiType.Photo:
        marker += "marker-photo.png";
        break;
      case PoiType.ApprocheLeft:
        marker += "marker-man-left.png";
        break;
      case PoiType.ApprocheRight:
        marker += "marker-man-right.png";
        break;
      default:
        return null;
    }
    return this.markerUrl + marker;
  }

  public initZoom(forceZoom: boolean) {
    if (this.map && (!this.isZoomInit || forceZoom)) {
      this.isZoomInit = true;
      setTimeout(() => {
        this.map.fitBounds(this.properties.maxBounds);
      }, 300);

    }
  }

  getSector(): Sector {
    return this.data.getSector(this.siteId, this.sectorId);
  }

  getPhotoPath(): PhotoPath {
    return this.getSector().photoPaths.find(photoPath_ => {
      return photoPath_.photo === this.photo.name;
    });
  }

  protected getPhotoSelected(): string {
    return this.photo.url;
  }

  ngOnInit(): void {
    RestProvider.getPhotoSize(this.photo.url).then((imageSize: ImageSize) => {
      this.isLoaded = true;
      this.properties.maxBounds = new LatLngBounds(latLng(-imageSize.height, 0), latLng(0, imageSize.width));
    });
    let photosPoi: string[] = [];
    this.getSector().photoPaths.forEach(photoPath => {
      photoPath.pois.forEach(poi => {
        if (poi.photo) photosPoi.push(poi.photo);
      });
    });
    if (this.data.isSectorOffline(this.sectorId)) {
      this.data.getPhotosOffline(photosPoi)
        .then(photos64 => {
          this.photos = [...photos64];
        })
    }
    else {
      this.photos = photosPoi.map(photo => {
        return {
          name: photo,
          url: DataProvider.getPhotoUrl(photo, false)
        }
      });
    }
  }

  protected isPath(polyline: number[][]): boolean {
    return polyline.length > 0;
  }

  protected getRouteFromSector(routeId: number): Route {
    return this.getSector().routes.find((route_: Route) => { return route_.id === routeId; });
  }

  protected getPolyline(polyline: number[][]) {
    return {
      type: "Feature",
      properties: {},
      geometry: {
        type: "LineString",
        coordinates: polyline
      }
    }
  }

  protected openPhotoPoi(poi: Poi) {
    this.navCtrl.push(PhotosViewerPage, {
      photos: [poi.photo]
    }).catch();
  }
}



// WEBPACK FOOTER //
// ./src/components/route-path-viewer/route-path-viewer.ts